import * as React from "react";

import { ElementUpdateLoadingIndicator } from "@editor/components/header/ElementUpdateLoadingIndicator";
import PageControlButtons from "@editor/components/header/PageControlButtons";

const RightBarHeader = () => {
  return (
    <div className="shadow-panel border-0.5 border-secondary absolute right-2 top-2 flex items-center gap-2 rounded-xl bg-white p-3">
      <ElementUpdateLoadingIndicator />
      <PageControlButtons />
    </div>
  );
};

export default RightBarHeader;
